import '../sass/Front/style.sass';
import {clipAdviser} from "./modules/clipAdviser";
import {searchResources} from "./modules/searchResources";
import {toggleActive} from "./modules/toggleActive";
import createPhotosUploader from "./modules/MultiPhotosUploader";
import {postQuestion} from "./modules/postQuestion";
import {postComment} from "./modules/postComment";
import {modalHelpfulReport} from "./modules/modalHelpfulReport";
import {scrollToTop} from "./modules/scrollToTop";
import {previewFormFields} from "./modules/previewFormFields";
import {transferResources} from "./modules/transferResources";
import {clipQuestion} from "./modules/clipQuestion";
import Swiper from "swiper";
import {swipeGalleryWithThumbs} from "./modules/swipeGalleryWithThumbs";
import {getResources} from "./modules/getResources";
import "./modules/scrollViewPopup";
import {fallbackCustomScheme} from "./modules/fallbackCustomScheme";
import {accordion} from "./modules/accordion";

document.addEventListener('DOMContentLoaded', () => {

  let last_known_scroll_position = 0;
  let ticking = false;
  const $top = document.getElementById('totop');
  const $scrollAction = document.getElementById('scroll-slide-in');
  const $tickingHeader = document.getElementById('tickingHeader');
  window.addEventListener('scroll', function(e) {
    last_known_scroll_position = window.scrollY;
    if (!ticking) {
      window.requestAnimationFrame(function () {
        const $overlayAd = document.getElementById('ats-custom-overlay-wrapper');
        let baseBottomHeight = Math.max(70, ($overlayAd ? ($overlayAd.offsetHeight + 20) : 0));
        // トップアンカーの表示/非表示
        if ($top) {
          if (last_known_scroll_position > 100) {
            $top.style.bottom = baseBottomHeight + 'px';
            $top.classList.add('ease-in');
            baseBottomHeight += 50;
          } else if ($top.classList.contains('ease-in') && !$top.classList.contains('ease-out')) {
            $top.classList.add('ease-out');
          }

        }
        // 追従バナーの表示/非表示
        if ($scrollAction) {
          if (last_known_scroll_position > 200) {
            Array.from($scrollAction.children).forEach(child => {
              child.style.bottom = baseBottomHeight + 'px';
              child.classList.add('is-in');
              baseBottomHeight += 60;
            });
          } else {
            Array.from($scrollAction.children).forEach(child => {
              child.classList.remove('is-in');
            });
          }
        }
        // ヘッダーの固定
        if ($tickingHeader) {
          if (window.innerWidth < 960) {
            $tickingHeader.classList.add('is-fixed');
          } else if (last_known_scroll_position > 65.63) {
            $tickingHeader.classList.add('is-fixed');
          } else {
            $tickingHeader.classList.remove('is-fixed');
          }
        }
        ticking = false;
      });
    }
    ticking = true;
  });

  document.querySelectorAll('.modal').forEach($modal => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (document.querySelector('.modal.is-active')) {
          document.body.classList.add('html-clipped');
        } else {
          document.body.classList.remove('html-clipped');
        }
      });
    });
    observer.observe($modal, { attributes: true });
  });

  Array.prototype.slice.call(document.querySelectorAll('.js-open-with-app'), 0).forEach($element => {
    $element.addEventListener('click', () => {
      fallbackCustomScheme($element.dataset.default);
    });
  });

  if (document.cookie.replace(/(?:(?:^|.*;\s*)token\s*\=\s*([^;]*).*$)|^.*$/, '$1').length > 0) {
    Array.prototype.slice.call(document.querySelectorAll('.js-member-only'), 0).forEach($el => {
      $el.classList.remove('is-hidden');
    });
  } else {
    Array.prototype.slice.call(document.querySelectorAll('.js-nonmember-only'), 0).forEach($el => {
      $el.classList.remove('is-hidden');
    });
  }

  let selectors;

  selectors = '.js-scroll-to-top';
  scrollToTop(Array.prototype.slice.call(document.querySelectorAll(selectors), 0));

  selectors = '.js-upload-photos';
  createPhotosUploader(Array.prototype.slice.call(document.querySelectorAll(selectors), 0));

  selectors = '.js-clip-adviser';
  clipAdviser(Array.prototype.slice.call(document.querySelectorAll(selectors), 0));

  selectors = '.js-clip-question';
  clipQuestion(Array.prototype.slice.call(document.querySelectorAll(selectors), 0));

  selectors = '.js-preview-form-fields';
  previewFormFields(Array.prototype.slice.call(document.querySelectorAll(selectors), 0));

  selectors = '.js-post-question';
  postQuestion(Array.prototype.slice.call(document.querySelectorAll(selectors), 0));

  selectors = '.js-post-comment';
  postComment(Array.prototype.slice.call(document.querySelectorAll(selectors), 0));

  selectors = '.js-modal-helpful-report';
  modalHelpfulReport(Array.prototype.slice.call(document.querySelectorAll(selectors), 0));

  selectors = '.js-transfer-resources';
  transferResources(Array.prototype.slice.call(document.querySelectorAll(selectors), 0));

  selectors = '.js-toggle-active';
  toggleActive(Array.prototype.slice.call(document.querySelectorAll(selectors), 0));

  selectors = '.js-get-resources';
  getResources(Array.prototype.slice.call(document.querySelectorAll(selectors), 0));

  selectors = '.js-accordion-trigger';
  accordion(Array.prototype.slice.call(document.querySelectorAll(selectors), 0));

  let hash;

  hash = 'edit-question';
  location.hash === ('#' + hash) && document.getElementById('js-anchor-' + hash) && document.getElementById('js-anchor-' + hash).click();

  hash = 'edit-comment';
  location.hash === ('#' + hash) && document.getElementById('js-anchor-' + hash) && document.getElementById('js-anchor-' + hash).click();
});

window.addEventListener('popstate', () => {
  sessionStorage.setItem('popstate', '1'); // ブラウザバック実行済み判定をセット（safari用）
});

window.addEventListener('load', () => {

  document.body.dataset.state = JSON.stringify(history.state);

  let selectors;

  selectors = '.js-swiper';
  Array.prototype.slice.call(document.querySelectorAll(selectors), 0).forEach(el => new Swiper(el, JSON.parse(el.dataset.swiperOptions)));

  selectors = '.js-swiper-thumbs-gallery';
  swipeGalleryWithThumbs(Array.prototype.slice.call(document.querySelectorAll(selectors), 0)).then((swipers) => {
    selectors = '.js-search-resources';
    searchResources(Array.prototype.slice.call(document.querySelectorAll(selectors), 0)).then((lazy) => {
      sessionStorage.setItem('load', location.pathname);
      swipers.forEach(swiper => {
        swiper.on('slideChangeTransitionEnd', () => {
          sessionStorage.setItem('load', location.pathname);
          if (lazy !== {}) {
            const slides = swiper.el.querySelectorAll('.swiper-slide[data-history]');
            const tabName = slides[swiper.activeIndex].dataset.history;
            if (tabName in lazy && lazy[tabName].length > 0) {
              const allFunc = lazy[tabName];
              lazy[tabName] = [];
              allFunc.forEach(func => func());
            }
          }
        });
      });
    });
  });

});
